import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/review-logo-website.png")